import { CustomInputQuestion } from "@/pages/quiz/15000/questions/CustomInput";
import { SingleChoiceQuestion } from "@/pages/quiz/15000/questions/SingleChoice";
import { DoctorPrescribeBanner } from "@/pages/quiz/15000/questions/DoctorPrescribeBanner";
import { AttachmentBlock } from "@/pages/quiz/15000/questions/AttachmentBlock";
import { ContactEmailField } from "@/pages/quiz/15000/questions/ContactEmail";
import { OnlyLicencedPharmaciesBanner } from "@/pages/quiz/15000/questions/OnlyLicencedPharmaciesBanner";
import { RealUsersRealResultsBanner } from "@/pages/quiz/15000/questions/RealUsersRealResultsBanner";
import { DoctorHealthHistoryBanner } from "@/pages/quiz/15000/questions/DoctorHealthHistoryBanner";
import { ApprovedByDoctorQuestion } from "@/pages/quiz/15000/questions/ApprovedByDoctorQuestion";
import { BenefitsCompareBanner } from "@/pages/quiz/15000/questions/BenefitsCompareBanner";
import { SelectTreatmentOptionBundleNew } from "@/pages/quiz/15000/questions/SelectTreatmentOption";
import { PreviewSelectTreatmentOption } from "@/pages/quiz/base/questions/selectTreatmentOption/common";
import { ContactDob } from "@/pages/quiz/15000/questions/ContactDob";
import { SelectState } from "@/pages/quiz/15000/questions/SelectState";
import { WeCanHelpYouLose } from "@/pages/quiz/15000/questions/WeCanHelpYouLose";
import { ContactForAvailablePlansAddress } from "@/pages/quiz/15000/questions/ContactForAvailablePlansAddress";
import { QuestionBlockResult } from "@/pages/quiz/context/types";
import { CustomFormBlock } from "@/types";
import { CustomGallbladderDate } from "@/pages/quiz/15000/questions/CustomGallbladderDate";
import { CustomDate } from "@/pages/quiz/15000/questions/CustomDate";
import { MedicationWaiverConsent } from "@/pages/quiz/15000/questions/MedicationWaiverConsent";
import { HeightWeightInputsWithBMI } from "@/pages/quiz/15000/questions/HeightWeightInputsWithBMI";
import { SelectSexQuestion } from "@/pages/quiz/15000/questions/SelectSex";
import { MultipleChoice } from "@/pages/quiz/15000/questions/MultipleChoice";
import { ErrorScreen } from "@/pages/quiz/15000/questions/ErrorScreen";
import { CustomNumberInputQuestion } from "@/pages/quiz/15000/questions/CustomNumberInput";

const componentMap: {
  [key: string]: QuestionBlockResult;
} = {
  "select-sex": {
    Component: SelectSexQuestion,
  },
  // cover special core questions for mobile app with simple feedback
  "app-highest-weight": {
    Component: CustomNumberInputQuestion,
  },
  "core-highest-weight": {
    Component: CustomNumberInputQuestion,
  },
  "glp-consent": {
    Component: SingleChoiceQuestion,
  },
  "core-glp-consent": {
    Component: SingleChoiceQuestion,
  },

  "app-weight-goal": {
    Component: CustomNumberInputQuestion,
  },
  "core-weight-goal": {
    Component: CustomNumberInputQuestion,
  },
  "select-state": {
    Component: SelectState,
  },
  "height-weight-input-fields-with-bmi": {
    Component: HeightWeightInputsWithBMI,
  },
  "custom-input-field": {
    Component: CustomInputQuestion,
  },
  "custom-email-field": {
    Component: ContactEmailField,
  },
  "custom-dob": {
    Component: ContactDob,
  },
  "medication-waiver-consent": {
    Component: MedicationWaiverConsent,
  },
  "medication-consent-update": {
    Component: MedicationWaiverConsent,
  },
  "custom-gallbladder-date": {
    Component: CustomGallbladderDate,
  },
  "custom-data": {
    Component: CustomDate,
  },
  "custom-contact-for-available-plans-address": {
    Component: ContactForAvailablePlansAddress,
  },
  "custom-select-treatment-option-bundle": {
    Component: SelectTreatmentOptionBundleNew,
    config: {
      prerenderMode: true,
      PreviewComponent: PreviewSelectTreatmentOption,
    },
  },
  "custom-single-choice": {
    Component: SingleChoiceQuestion,
  },
  "benefits-compare-hero": {
    Component: BenefitsCompareBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "custom-multiple-choice": {
    Component: MultipleChoice,
  },
  "custom-multiple-choice-oral-reasons": {
    Component: MultipleChoice,
  },
  "error-screen": {
    Component: ErrorScreen,
  },
  "custom-attachment": {
    Component: AttachmentBlock,
  },

  "full-body-photo-attachment": {
    Component: AttachmentBlock,
  },

  // banners
  "approved-banner-hero": {
    Component: ApprovedByDoctorQuestion,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "doctors-prescribe-banner": {
    Component: DoctorPrescribeBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "only-licenced-pharmacies-banner": {
    Component: OnlyLicencedPharmaciesBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "real-users-real-results-banner": {
    Component: RealUsersRealResultsBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "doctor-health-history-banner": {
    Component: DoctorHealthHistoryBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "loose-weight-plot": {
    Component: WeCanHelpYouLose,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "loose-weight-plot-banner": {
    Component: WeCanHelpYouLose,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
};

const emptyResult: QuestionBlockResult = {
  Component: () => null,
  config: {},
};

export const getQuestionBlock = (selectedQuestion: CustomFormBlock | null) =>
  componentMap[selectedQuestion?.name ?? ""] || emptyResult;
